import { AssetEvent } from './asset.event';
import { EventRegistry } from '../../../../../domain/event/event.registry';
export class AssetRemovePhotoEvent extends AssetEvent {
    constructor(payload, metadata, fromPersistence) {
        super({
            subject: `asset-class/${payload.assetClassId}/asset/${payload.id}`,
            type: AssetRemovePhotoEvent.type,
            payload,
            metadata,
            fromPersistence,
        });
    }
}
AssetRemovePhotoEvent.type = 'com.treeplotter.api.asset.removePhoto.v1';
EventRegistry.register(AssetRemovePhotoEvent.type, AssetRemovePhotoEvent);
//# sourceMappingURL=asset-remove-photo.event.js.map